import { AlertColor } from '@mui/material'
import { atom } from 'recoil'

export type WotcConfig = {
  clientId: string
  active: boolean
  organizationCode?: string
  providerName?: string
  marketIntegration?: boolean
  selectedProvider?: string,
  selectedOrganizationCode?: string,
  legacyClientId?: number,
  locations?: ProviderLocations[],
  linkedFromClientId?: string,
}

export type CCTConfig = {
  showAlert: boolean;
  isUpdate: boolean;
  alertTitle?: string;
  alertMessage?: string;
  alertSeverity?: AlertColor;
  orgError: boolean;
  vendorListError: boolean;
}

const wotcConfig = {
  active: false,
  clientId: '',
  legacyClientId: 0,
  locations: [],
  marketIntegration: false,
  organizationCode: '',
  providerName: '',
  selectedOrganizationCode: '',
  selectedProvider: ''

} as WotcConfig

const cctConfig = {
  isUpdate: false,
  showAlert: false
} as CCTConfig

export type ProviderLocations = {
  id: string;
  providerLocationId: string;
}


const wotcConfigState = atom({
  default: { cctConfig, wotcConfig },
  key: 'wotcState',
})

export default wotcConfigState